import { API_BASE_URL } from '../config';

const superAdminService = {
  
  getStats: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/stats`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to fetch stats');
    return await response.json();
  },

  getAllDealers: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/dealers`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to fetch dealers');
    return await response.json();
  },

  getAllSurveys: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/surveys`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to fetch surveys');
    return await response.json();
  },

  getAllResponses: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/responses`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to fetch responses');
    return await response.json();
  },

  getAllImages: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/images`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Failed to fetch images');
    return await response.json();
  },

  getAllQuotes: async () => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/quotes`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error("Server Error Quotes:", errorText);
        throw new Error(errorText || 'Failed to fetch quotes');
    }
    return await response.json();
  },

  getQuotePrice: async (id) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/quote/${id}/breakdown`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) return null; // Fail silently if price calc fails
    return await response.json();
  },

  getDealerDetails: async (dealerId) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/dealer/${dealerId}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Failed to fetch dealer details');
    return await response.json();
  },

  promoteUser: async (userId) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/user/${userId}/promote`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Failed to promote user');
    return await response.json();
  },

  demoteUser: async (userId) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/user/${userId}/demote`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Failed to demote user');
    return await response.json();
  },

  createDealer: async (dealerData) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/dealer`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dealerData)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to create dealer');
    }
    return await response.json();
  },

  deleteDealer: async (dealerId) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/dealer/${dealerId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Failed to delete dealer');
    return true;
  },

  deleteUser: async (userId) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/SuperAdmin/user/${userId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to delete user');
    }
    return true;
  },
};

export default superAdminService;